export default {
  purchasingRoles: [
    {
      id: 'user',
      name: 'I will use the software day-to-day',
    },
    {
      id: 'purchase approver',
      name: 'I will oversee the purchasing of the software',
    },
    {
      id: 'security approver',
      name: 'I will evaluate the security and compliance of the software',
    },
    {
      id: 'maintainer',
      name: 'I will set up and maintain the software for my organization',
    },
    {
      id: 'other',
      name: 'Other',
    },
  ],
  reasons: [
    {
      id: 'account capture',
      name: 'Account capture to see who in my organization is using Zapier',
    },
    {
      id: 'multiple teams',
      name: 'To organize my members into teams',
    },
    {
      id: 'app access control',
      name: 'To set restrictions on which apps my employees can access',
    },
    {
      id: 'data retention',
      name: 'Custom data retention',
    },
    {
      id: 'saml',
      name: 'Single sign-on (SAML)',
    },
    {
      id: 'scim',
      name: 'User provisioning (SCIM)',
    },
    {
      id: 'task limits',
      name: 'I want to increase my task limits',
    },
    {
      id: 'other',
      name: 'Other',
    },
  ],
  roles: [
    {
      id: 'Accountant',
      name: 'Accountant',
    },
    {
      id: 'Business Development',
      name: 'Business Development Professional',
    },
    {
      id: 'Business Owner or Founder',
      name: 'Business Owner or Founder',
    },
    {
      id: 'Customer Service Rep',
      name: 'Customer Service Representative',
    },
    {
      id: 'Data Science Engineer',
      name: 'Data Science Engineer',
    },
    {
      id: 'Designer',
      name: 'Designer',
    },
    {
      id: 'DevOps Engineer',
      name: 'DevOps Engineer',
    },
    {
      id: 'Facilities Manager',
      name: 'Facilities Manager',
    },
    {
      id: 'Financial Advisor',
      name: 'Financial Advisor',
    },
    {
      id: 'Fitness Coach',
      name: 'Fitness Coach',
    },
    {
      id: 'Health',
      name: 'Health Professional',
    },
    {
      id: 'Human Resources',
      name: 'Human Resources Professional',
    },
    {
      id: 'Information Technology',
      name: 'Information Technology Professional',
    },
    {
      id: 'Legal',
      name: 'Legal Professional',
    },
    {
      id: 'Marketer',
      name: 'Marketer',
    },
    {
      id: 'Mechanical Engineer',
      name: 'Mechanical Engineer',
    },
    {
      id: 'Office Manager',
      name: 'Office Manager',
    },
    {
      id: 'Operations',
      name: 'Operations Professional',
    },
    {
      id: 'Other',
      name: 'Other',
    },
    {
      id: 'Personal Assistant',
      name: 'Personal Assistant',
    },
    {
      id: 'President or CEO',
      name: 'President or CEO',
    },
    {
      id: 'Product Manager',
      name: 'Product Manager',
    },
    {
      id: 'Project Manager',
      name: 'Project Manager',
    },
    {
      id: 'Property Manager',
      name: 'Property Manager',
    },
    {
      id: 'Public Relations',
      name: 'Public Relations Professional',
    },
    {
      id: 'Real Estate Agent',
      name: 'Real Estate Agent',
    },
    {
      id: 'Recruiter',
      name: 'Recruiter',
    },
    {
      id: 'Salesperson',
      name: 'Salesperson',
    },
    {
      id: 'School Administrator',
      name: 'School Administrator',
    },
    {
      id: 'Software Engineer',
      name: 'Software Engineer',
    },
    {
      id: 'Student',
      name: 'Student',
    },
    {
      id: 'Educator',
      name: 'Teacher or Professor',
    },
    {
      id: 'Web Engineer',
      name: 'Web Engineer',
    },
    {
      id: 'Writer or Editor',
      name: 'Writer or Editor',
    },
  ],
  sizes: [
    {
      id: '1-9',
      name: '1 - 9',
    },
    {
      id: '10-24',
      name: '10 - 24',
    },
    {
      id: '25-49',
      name: '25 - 49',
    },
    {
      id: '50-249',
      name: '50 - 249',
    },
    {
      id: '250-499',
      name: '250 - 499',
    },
    {
      id: '500-999',
      name: '500 - 999',
    },
    {
      id: '1000+',
      name: '1000 +',
    },
  ],
};
